var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8954_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 1.99988H6.00012V7.99988H33.9999V1.99988H35C35.5522 1.99988 36.0001 1.55237 36.0001 1.00012C36.0001 0.447876 35.5522 0 35 0H5C4.44775 0 3.99988 0.447876 3.99988 1.00012C3.99988 1.55237 4.44775 1.99988 5 1.99988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 31.9999C35.5522 31.9999 36.0001 31.5524 36.0001 31.0001C36.0001 30.4479 35.5522 30 35 30H5C4.44775 30 3.99988 30.4479 3.99988 31.0001C3.99988 31.5524 4.44775 31.9999 5 31.9999H6.00012V37.9999H5C4.44775 37.9999 3.99988 38.4478 3.99988 39C3.99988 39.5522 4.44775 40.0001 5 40.0001H35C35.5522 40.0001 36.0001 39.5522 36.0001 39C36.0001 38.4478 35.5522 37.9999 35 37.9999H33.9999V31.9999H35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 10.0001H5C4.44775 10.0001 3.99988 10.4476 3.99988 10.9999C3.99988 11.5521 4.44775 12 5 12H6.00012V28.0001H33.9999V12H35C35.5522 12 36.0001 11.5521 36.0001 10.9999C36.0001 10.4476 35.5522 10.0001 35 10.0001ZM20 24C17.7917 23.9974 16.0024 22.2081 15.9999 19.9999C15.9999 18.212 18.0917 13.9999 20 13.9999C21.9083 13.9999 24.0001 18.212 24.0001 19.9999C23.9976 22.2081 22.2083 23.9974 20 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16.0693C19.3145 16.6102 18.0001 18.8712 18.0001 19.9999C18.0001 21.1047 18.8955 22.0001 20 22.0001C21.1045 22.0001 21.9999 21.1047 21.9999 19.9999C21.9999 18.8712 20.6855 16.6102 20 16.0693Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8954_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.c80864f3b9b348a094c454e6491c92a4.svg";
export { ForwardRef as ReactComponent };